var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w-4",attrs:{"data-testid":"mainMenuButton"},on:{"click":_vm.toggleNavigation}},[_c('span',{staticClass:"text-sm",class:_vm.isNavigationOpen ?
      'iconify svg--menu-close text-EXPONDO-orange' :
      'iconify svg--burger-menu text-EXPONDO-primary'})])}
var staticRenderFns = []

export { render, staticRenderFns }